import React from 'react';
import { WithIcon } from './WithIcon';

export const IconRss = WithIcon(
  'RSS',
  '0 0 8 8',
  <>
    <circle cx="2" cy="6" r="1" />
    <path d="m 1,4 a 3,3 0 0 1 3,3 h 1 a 4,4 0 0 0 -4,-4 z" />
    <path d="m 1,2 a 5,5 0 0 1 5,5 h 1 a 6,6 0 0 0 -6,-6 z" />
  </>
);
